module.exports = __webpack_public_path__ + "img/university_16.8e8e81b7.png";